export const GameConfig = {
  CANVAS_WIDTH: (window.innerWidth * 9) / 10,
  CANVAS_HEIGHT: (window.innerHeight * 3) / 4,

  PARALLAX: {
    WIDTH: 2000,
    HEIGHT: 1176,
    LAYER_1_SPEED_MODIFIER: 0.7,
    LAYER_2_SPEED_MODIFIER: 0.5,
    LAYER_3_SPEED_MODIFIER: 0.4,
    LAYER_4_SPEED_MODIFIER: 0.2,
  },
  GAME_SPEED: 5,

  ENEMY_GENERATION_INTERVAL_MS: 1000,
  PICKUP_GENERATION_INTERVAL_MS: 10000,

  FPS: 15,
  FRAME_TIMER: 0,
  FRAME_INTERVAL: function () {
    return 1000 / this.FPS;
  },
  WEAPON_RANGE_BUFFER: 0.8,

  TOTAL_AMMO: 50,
  AMMO_INTERVAL_MS: 500,

  UI: {
    FONT_SIZE: "20px",
    FONT_FAMILY: "Silkscreen",
    COLOR: "grey",
  },
};

export const GameUIConfig = {
  SCORE: {
    X: 10,
    Y: 30,
  },
  ImageUI: {
    X: GameConfig.CANVAS_WIDTH - 100,
    Y: 30,

    SPRITE_WIDTH: 32,
    SPRITE_HEIGHT: 32,
  },
  BulletUI: {
    IMG_SRC: "./assets/UI/bullet.png",

    SPRITE_WIDTH: 32,
    SPRITE_HEIGHT: 32,

    X: 10,
    Y: 60,

    TEXT_X: 40,
    TEXT_Y: 60,
  },
  GameOver: {
    X: GameConfig.CANVAS_WIDTH / 2 - 200,
    Y: GameConfig.CANVAS_HEIGHT / 2,

    FONT_SIZE: "50px",
    FONT_FAMILY: "Silkscreen",
    COLOR: "grey",
  },
};

export const InputConfig = {
  UP: "ArrowUp",
  DOWN: "ArrowDown",
  ATTACK: "ArrowRight",
};
